// extracted by css-extract-rspack-plugin
export default {"chip":"chip-xBuM9R","themedChip":"themedChip-rFcpEs"};